import { ElementRef, Renderer2 } from '@angular/core';
import { CommonService } from "../../common.service";
import { ApiService } from '../../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppChartsService } from '../../app-charts/app-charts.service';
import { CampSurveyReportService } from './camp-survey-report.service';
import { PlatformLocation } from '@angular/common';
var CampSurveyReportComponent = (function () {
    function CampSurveyReportComponent(router, apiService, route, el, render, commonService, platformLocation) {
        this.router = router;
        this.apiService = apiService;
        this.route = route;
        this.el = el;
        this.render = render;
        this.commonService = commonService;
        this.platformLocation = platformLocation;
        this.chartsType = "radar"; //图表类型
        this.theme = "survey"; //主题
        this.contrast = "Good"; //对比结果
        this.chartKAsData = []; //图表数据
        this.assetsRoute = "../../../assets";
        this.returnTxt = "";
        this.currentIndex = 0;
        this.showInfo = true;
        this.isOpenClass = 0;
        this.isSlide = false;
        this.isFirstInPreOrPostTestReport = false; //是否第一次进入报告
        this.isScrollBottom = false; //是否滚到底部
        this.isShowApproachModule = false; //是否显示趋近
        this.isShowShare = false; //是否跳转分享功能
        this.approachLoading = false;
        this.approachTheme = {};
        this.isPC = false;
        this.showPCBtn = false;
        this.isShowBack = false;
        this.isOnlyLearningPathCannotBack = false;
        this.isCustomLock = false; //用户有没有强制锁定
        this.lock = false;
        this.isShowToast = false;
    }
    CampSurveyReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.projectId = localStorage.getItem("projectId");
        var projectmsg = JSON.parse(localStorage.getItem('projectmsg'));
        if (this.projectId && projectmsg) {
            projectmsg.map(function (item) {
                if (item.type == 2 && item.lockType == 1) {
                    _this.lock = item.lock;
                    _this.promptText = "\u8BFE\u7A0B\u5B66\u4E60\u5C06\u4E8E" + item.promptTime + "\u5F00\u653E\u3002";
                }
            });
        }
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
        this.isPC = !!localStorage.getItem('isPC');
        this.abilityName = {
            406: '目标设定',
            403: '任务授权',
            405: '辅导他人',
            496: '绩效追踪',
            426: '目标设定',
            423: '任务授权',
            425: '辅导他人',
            4296: '绩效追踪',
        }[Number(localStorage.getItem('learningPathMetaId'))] || '';
        this.isShowBack = this.platformLocation['location']['href'].indexOf('isShowBack') !== -1;
        this.isOnlyLearningPathCannotBack = !!localStorage.getItem('isOnlyLearningPathCannotBack');
        this.showPCBtn = this.isPC;
        this.appChartsService = new AppChartsService();
        this.abilityReportNewService = new CampSurveyReportService(this.apiService);
        this.getApiData();
    };
    CampSurveyReportComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        $('body').addClass('heightAuto');
        var audioEle = this.el.nativeElement.querySelector('#audioPlay');
        this.commonService.initPage();
        this.timer = setTimeout(function () {
            _this.isSlide = false;
            _this.showInfo = false;
            audioEle && _this.render.addClass(audioEle, 'displayNone');
        }, 5000);
        var that = this;
        if (!that.isPC) {
            setTimeout(function () {
                _this.hammertime = new Hammer(document.getElementById('swipeContainer'));
                _this.hammertime.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
                _this.hammertime.on('swipeup swipedown', function (ev) {
                    that.logEventType(ev, that);
                });
            }, 500);
        }
    };
    CampSurveyReportComponent.prototype.goNext = function () {
        var _this = this;
        $('#swipeContainer').css({
            'top': '-100%',
            'opacity': '0'
        });
        setTimeout(function () {
            $(".abilityReport").css({ 'opacity': '1' });
            $('#swipeContainer').hide();
            _this.slideBtn();
        }, 300);
    };
    CampSurveyReportComponent.prototype.logEventType = function (ev, that) {
        var _this = this;
        if (ev.type == "swipeup") {
            $('#swipeContainer').css({
                'top': '-100%',
                'opacity': '0'
            });
            that.hammertime.get('swipe').set({ enable: false });
            setTimeout(function () {
                $(".abilityReport").css({ 'opacity': '1' });
                $('#swipeContainer').hide();
                _this.slideBtn();
            }, 300);
        }
    };
    //根据type获取数据
    CampSurveyReportComponent.prototype.getApiData = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            _this.cid = params['cid'];
            _this.surveyStatus = params['typeId'];
            _this.courseId = params['courseId'];
            _this.learningPathId = params['learningPathId'];
            _this.staticDoc = _this.abilityReportNewService.getStaticDoc(_this.surveyStatus);
            _this.abilityReportNewService.getUserIsFirstInPreOrPostTestReport(_this.cid, _this.surveyStatus).then(function (result) {
                _this.isFirstInPreOrPostTestReport = Number(result.data) === 0 ? true : false;
                _this.approachTheme.isFirst = _this.isFirstInPreOrPostTestReport;
                if (_this.isFirstInPreOrPostTestReport) {
                    _this.abilityReportNewService.saveUserFirstInPreOrPostTestReport(_this.cid, _this.surveyStatus).then();
                }
            }).then(function () {
                _this.getReport(Number(_this.surveyStatus));
            });
        });
    };
    //获取报告
    CampSurveyReportComponent.prototype.getReport = function (surveyStatus) {
        var _this = this;
        if (surveyStatus == 1) {
            localStorage.setItem('moduleId', '1');
            this.pageTitle = "学前检测报告";
            this.abilityReportNewService.getPreTestReport(this.cid).then(function (result) {
                _this.report = result;
                _this.level = _this.report.level ? _this.report.level : 1;
                _this.scoreStr = { 1: '薄弱', 2: '有限', 3: '一般', 4: '良好', 5: '优秀', 6: '卓越' }[_this.level];
                _this.levelDesc = _this.report.levelDesc;
                _this.courseName = _this.report.courseName;
                _this.teacherName = _this.abilityReportNewService.getTeacherName(_this.courseName);
                _this.suggest = _this.report.b_suggest;
                _this.learningTips = _this.report.learningTips;
                _this.chartKAsData = _this.report.moduleLevel ? _this.formatCampSurveyChartData(_this.report.moduleLevel) : null;
                console.log(_this.chartKAsData);
                // this.chartKAsData = this.report.kas ? [this.report.kas] : [[{"kaName":"KA1","kaScore":10},{"kaName":"KA2","kaScore":10},{"kaName":"KA3","kaScore":10},{"kaName":"KA4","kaScore":10},{"kaName":"KA5","kaScore":10}]];
            }).then(function () {
                _this.approachTheme.colorSystem = 'dark';
                _this.approachTheme.label = ['能力诊断', '课程学习', '情景模拟', '能力考核'];
                _this.approachTheme.currentIndex = _this.currentIndex - 2;
                _this.approachTheme.desc = '知道了自己的能力画像，是否希望更上层楼？';
                _this.approachTheme.btnTxt = '开启课程学习';
            }).then(function () {
                _this.approachLoading = true;
                //增加学习断点
                _this.commonService.addUserBreakPoint({ 'learningPathMetasId': Number(_this.cid), 'moduleId': 1, 'breakpointUrl': _this.platformLocation['location']['href'], 'projectId': localStorage.getItem("projectId") ? localStorage.getItem("projectId") : null }).then();
            });
        }
        else if (surveyStatus == 2) {
            this.pageTitle = "综合考核报告";
            localStorage.setItem('moduleId', '4');
            this.abilityReportNewService.getPostTestReport(this.cid).then(function (result) {
                _this.report = result;
                _this.courseName = _this.report.courseName;
                // this.returnTxt = {1:"返回公开课",2:"返回体验课"}[Number(localStorage.getItem('companiesType'))]||"完成"+this.courseName;
                _this.contrastSpeech = _this.report.contrastSpeech;
                _this.contrastDesc = _this.report.contrastDesc;
                _this.teacherName = _this.abilityReportNewService.getTeacherName(_this.courseName);
                _this.level = _this.report.b_level && _this.report.a_level ? [_this.report.b_level, _this.report.a_level] : [1, 1];
                _this.a_advantagesKas = _this.report.a_advantagesKas;
                _this.a_shortBoardsKas = _this.report.a_shortBoardsKas;
                _this.shortBoardsFixedSpeech = _this.report.shortBoardsFixedSpeech;
                _this.advantagesFixedSpeech = _this.report.advantagesFixedSpeech;
                _this.fixedSpeech = _this.report.fixedSpeech;
                _this.developmentTipsKas = _this.report.newDevelopmentTipsKas;
                _this.developmentTipsFixedSpeech = _this.report.developmentTipsFixedSpeech;
                _this.developmentTipsTransition = _this.report.developmentTipsTransition;
                // this.chartKAsData = this.report.b_kas && this.report.a_kas ? [this.report.a_kas, this.report.a_kas]: [this.report.a_kas, this.report.a_kas];
                _this.chartKAsData = _this.report.moduleLevel ? _this.formatCampSurveyChartData(_this.report.moduleLevel) : null;
            }).then(function () {
                _this.approachTheme.colorSystem = 'dark';
                _this.approachTheme.label = ['能力诊断', '课程学习', '情景模拟', '能力考核'];
                // this.approachTheme.currentIndex = 3;
                _this.approachTheme.currentIndex = _this.currentIndex - 2;
                _this.approachTheme.desc = '';
                _this.approachTheme.btnTxt = "完成" + _this.courseName;
                _this.approachLoading = true;
                //增加学习断点
                _this.commonService.addUserBreakPoint({ 'learningPathMetasId': Number(_this.cid), 'moduleId': 4, 'breakpointUrl': _this.platformLocation['location']['href'], 'projectId': localStorage.getItem("projectId") ? localStorage.getItem("projectId") : null }).then();
            });
        }
    };
    // 设置LineCharts（等级对象）
    CampSurveyReportComponent.prototype.setLineChartsData = function (level) {
        if (typeof (level) === "number") {
            var querySelector = this.el.nativeElement.querySelector('#lv' + level);
            this.render.addClass(querySelector, "post");
        }
        else if (typeof (level) === "object" && level.constructor === Array) {
            var classNames = ['pre', 'post'], domFirstName = ".lv";
            for (var i = 0, len = level.length; i < len; i += 1) {
                if (level[i] === level[i + 1]) {
                    classNames = ['eqPre', 'eqPost'];
                    this.contrast = "Normal";
                }
                else if (level[i] < level[i + 1]) {
                    this.contrast = "Good";
                    domFirstName = "#lv";
                }
                else if (level[i] > level[i + 1]) {
                    classNames = ['pre', 'post'];
                    this.contrast = "Bad";
                }
                this.render.addClass(this.el.nativeElement.querySelector(domFirstName + level[i]), classNames[i]);
            }
        }
    };
    CampSurveyReportComponent.prototype.formatCampSurveyChartData = function (reportLevel) {
        var chartData = [], b_kas = [], a_kas = [];
        //{kaName: "说明讨论的目的", kaScore: 10}
        for (var i = 0, len = reportLevel.length; i < len; i += 1) {
            b_kas.push({ 'kaName': reportLevel[i].moduleName, 'kaScore': reportLevel[i].b_moduleLevel });
            if (Number(this.surveyStatus) === 2) {
                a_kas.push({ 'kaName': reportLevel[i].moduleName, 'kaScore': reportLevel[i].a_moduleLevel });
            }
        }
        chartData[0] = b_kas;
        if (Number(this.surveyStatus) === 2) {
            chartData[1] = a_kas;
        }
        return chartData;
    };
    // 音频收缩
    CampSurveyReportComponent.prototype.slideBtn = function () {
        var _this = this;
        console.log(this.timer);
        var audioEle = this.el.nativeElement.querySelector('#audioPlay');
        if (this.isSlide) {
            this.showInfo = false;
            this.isSlide = false;
            audioEle && this.render.addClass(audioEle, 'displayNone');
            clearTimeout(this.timer);
        }
        else {
            this.showInfo = true;
            this.isSlide = true;
            audioEle && this.render.removeClass(audioEle, 'displayNone');
            this.timer = setTimeout(function () {
                _this.isSlide = false;
                _this.showInfo = false;
                audioEle && _this.render.addClass(audioEle, 'displayNone');
            }, 5000);
        }
    };
    // 获取课程
    CampSurveyReportComponent.prototype.getCourse = function () {
        if (Number(this.surveyStatus) === 1) {
            this.router.navigate(['learning-path', this.cid]);
        }
        else if (Number(this.surveyStatus) === 2) {
            this.router.navigate(['course-new', this.learningPathId, this.courseId], { queryParams: { 'isLastDay': '1' } });
        }
    };
    CampSurveyReportComponent.prototype.showToast = function () {
        var _this = this;
        this.isShowToast = true;
        setTimeout(function () {
            _this.isShowToast = false;
        }, 2000);
    };
    // 完成课程
    CampSurveyReportComponent.prototype.finishCourse = function () {
        var _this = this;
        this.commonService.addUserBreakPoint({ 'learningPathMetasId': Number(this.cid), 'moduleId': -1, 'breakpointUrl': null, 'projectId': localStorage.getItem("projectId") ? localStorage.getItem("projectId") : null }).then();
        this.commonService.getOnceIno(this.commonService.getOnceValue(this.cid, 10)).then(function (result) {
            var projectId = localStorage.getItem("projectId");
            if (_this.cid == 30) {
                if (projectId) {
                    _this.router.navigate(['learning-project', projectId]);
                    return;
                }
                _this.router.navigate(['learning-map']);
            }
            else {
                if (result === 1) {
                    if (localStorage.getItem('skuId') && !localStorage.getItem('onlyCamp')) {
                        _this.router.navigate(['learning-camp', localStorage.getItem('skuId'), localStorage.getItem('campId')]);
                    }
                    else if (localStorage.getItem('skuId') && localStorage.getItem('onlyCamp')) {
                        _this.router.navigate(['learning-camp', localStorage.getItem('skuId'), localStorage.getItem('campId'), -1]);
                    }
                    else if (!localStorage.getItem('skuId')) {
                        if (projectId) {
                            _this.router.navigate(['learning-project', projectId]);
                            return;
                        }
                        _this.router.navigate(['learning-map']);
                    }
                }
                else {
                    _this.router.navigate(['share', _this.cid]);
                }
            }
            // let link = this.cid == 30 ? ['learning-map'] : result === 1 ? ['learning-map'] : ['share', this.cid];
            $('body').removeClass('heightAuto');
            // this.router.navigate(link);
            _this.commonService.setOnceIno(_this.commonService.getOnceValue(_this.cid, 10)).subscribe();
        });
    };
    // 关闭
    CampSurveyReportComponent.prototype.close = function () {
        $('body').removeClass('heightAuto');
        this.getCourse();
    };
    return CampSurveyReportComponent;
}());
export { CampSurveyReportComponent };



// WEBPACK FOOTER //
// ./src/app/learning-camp/camp-survey-report/camp-survey-report.component.ts.pre-build-optimizer.js